import { render, staticRenderFns } from "./UiRangeInput.vue?vue&type=template&id=9021b988&scoped=true"
import script from "./UiRangeInput.vue?vue&type=script&lang=js"
export * from "./UiRangeInput.vue?vue&type=script&lang=js"
import style0 from "./UiRangeInput.vue?vue&type=style&index=0&id=9021b988&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9021b988",
  null
  
)

export default component.exports